module.exports = __webpack_public_path__ + "img/sheep.79518a8.png";